import { getComposeStore } from 'owa-calendar-compose-store-manager';
import { populateLocationSuggestions } from 'owa-location-suggestions-cache/lib/utils/populateLocationSuggestions';

export default function refreshLocationSuggestions() {
    const event = getComposeStore().event;
    populateLocationSuggestions(event, 'All' /*search mode of the location well in compose*/);
}
